var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebarBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 585,
    viewBox: "0 0 320 585",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.02,
    clipPath: "url(#clip0_5255_34031)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M491 278.331V394.359L-182 228.767V112.688L491 278.331Z",
    fill: "#12355B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491 0V112.669H-182V56.3344C-182 25.2212 -144.339 0 -97.8813 0H491Z",
    fill: "#12355B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491 468.949V584.98L-182 419.387V303.307L491 468.949Z",
    fill: "#F5862E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5255_34031"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 673,
    height: 585,
    fill: "white",
    transform: "translate(-182)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarBackground);
export default __webpack_public_path__ + "static/media/sidebar-background.fa81be27f1bd37d0425098561ae46a8d.svg";
export { ForwardRef as ReactComponent };